export const FULFILL_OVERVIEW = 'OFFERING.FULFILL_OVERVIEW';
export const FULFILL_PLACED_BIDS = 'OFFERING.FULFILL_PLACED_BIDS';
export const FULFILL_SCHEDULED_PAYMENTS = 'OFFERING.SCHEDULED_PAYMENTS';
export const FULFILL_PAYMENT_HISTORY = 'OFFERING.PAYMENT_HISTORY';
export const FULFILL_INVESTORS = 'OFFERING.FULFILL_INVESTORS';
